module.exports = __webpack_public_path__ + "static/media/bubble_09.677ff776.jpg";